/** @jsxImportSource @emotion/react */
import type { Interpolation } from "@emotion/react";
import { I18nMessage } from "@i18n/react";
import { Text, type ThemeType } from "@packages/ui";
import type { HTMLAttributes } from "react";

import { MATRIX_LENGTH } from "../../lib/constants/matrix";
import type { Game } from "../../schema";
import { MatrixItem } from "./MatrixItem";

const cssDivContainer: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.s,
  width: "100%",
});
const cssDivContainerMatrix: Interpolation<ThemeType> = (theme) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 20px)",
  gap: theme.spacing.t,
  width: "fit-content",
});
const cssTextMatrixGuesses: Interpolation = {
  textAlign: "center",
};

export const Matrix = ({
  matrix,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  matrix: Game["state"]["summary"]["matrix"];
}) => (
  <div css={cssDivContainer}>
    <div css={cssDivContainerMatrix} {...props}>
      {matrix
        .slice(0, 8)
        .flat()
        .map((entry, index) => (
          <MatrixItem difficulty={entry.difficulty} key={index} />
        ))}
    </div>
    {matrix.length > MATRIX_LENGTH && (
      <Text css={cssTextMatrixGuesses} size="s" type="body">
        <I18nMessage
          message="games_categories_dynamic_guesses"
          values={{
            games_categories_dynamic_guesses: matrix.length - MATRIX_LENGTH,
          }}
        />
      </Text>
    )}
  </div>
);
